import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import React from "react";
import ASCButton from "../../../components/Button";

function ConfirmationPopup(props: any) {
  return (
    <Dialog open={props.confirmationPopup}>
      <DialogSurface>
        <DialogTitle style={{ fontSize: 16 }}>
          Don't forget to change any allocation amounts that are attached to
          this commission entry
        </DialogTitle>
        <DialogActions>
          <div className="button-end-popup">
            <ASCButton
              shape="rounded"
              appearance="secondary"
              onClick={() => {
                props.setReceiptEditpopup(true);
                props.setConfirmationPopup(false);
              }}
              label="Ok"
            />
          </div>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default ConfirmationPopup;
